export interface PresentationMonth {
  /** YYYY-MM */
  value: string;
  label: string;
}

const MONTH_LABEL = new Intl.DateTimeFormat('it-IT', { month: 'long', year: 'numeric' });

function presentationMonth(today: Date, offset: number): PresentationMonth {
  const date = new Date(today.getFullYear(), today.getMonth() + offset, 1);
  const label = MONTH_LABEL.format(date);
  return {
    value: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`,
    label: label.charAt(0).toUpperCase() + label.slice(1),
  };
}

/** I soli mesi ammessi alla presentazione: precedente, corrente e prossimo. */
export const presentationMonths = (today = new Date()): [PresentationMonth, PresentationMonth, PresentationMonth] => [
  presentationMonth(today, -1),
  presentationMonth(today, 0),
  presentationMonth(today, 1),
];
